window.WebFont = require('webfontloader');

/** Web Font Load */
window.addEventListener('load', function () {
    WebFont.load({
        google: {
            families: [
                'Poppins:400,500,600'
            ]
        }
    });
});
